import React, { ReactNode, useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { selectCard } from 'js/actions';
import DateUtils from 'js/lib/DateUtils';
import { AvailableFilters } from 'js/components/MacroInput/types/AvailableFilters';
import { SearchFilterTypes, SearchFilterViews } from 'js/constants/visibilityFilters';
import { useListOldReduxContainer } from 'new/elements/DataCard/useListOldReduxContainer';
import DataCardList from 'new/elements/DataCardList';
import { useAppListing } from 'new/hooks/useAppListing';
import { renderDataCardRow } from 'new/components/settings/Authentication/ServiceKeys/ServiceKeysTable/renderDataCardRow';

import { ServiceKeyDetailHeader } from 'new/components/settings/Authentication/ServiceKeys/ServiceKeyDetailHeader/ServiceKeyDetailHeader';
import { useGetFilteredServiceKeys } from 'new/components/settings/Authentication/ServiceKeys/useGetFilteredServiceKeys';
import { mapStateToProps } from 'js/components/data_sets/cards/stateMapper';

type Props = {
  urlId?: string;
  isLoading: boolean;
  detailViewTabs: any[];
  noContentView: ReactNode;
  /**
   * dispatch every time these values change
   * @param page
   * @param sortCriteria
   * @param availableFilters
   */
  loadData: (page: number, sortCriteria: string, availableFilters: AvailableFilters) => void;
};

const availableFilterTypes = [
  SearchFilterTypes.ID,
  SearchFilterTypes.NAME,
  SearchFilterTypes.DESCRIPTION,
];

const view: string = SearchFilterViews.SERVICE_KEYS;

export const ServiceKeysTable = (props: Props) => {
  const { urlId, isLoading, detailViewTabs, loadData, noContentView } = props;
  const dispatch = useDispatch();
  const data = useGetFilteredServiceKeys();
  const { selectedCardId } = useAppListing();

  const handleCardSelected = useCallback((row) => {
    dispatch(selectCard(row.id));
  }, []);

  useEffect(() => {
    if (urlId) {
      handleCardSelected({ id: urlId });
    }
  }, []);

  const getData = useListOldReduxContainer(data, mapStateToProps, (ownProps: { cardData: any }) => {
    const { cardData } = ownProps;
    const { status, name = 'Untitled', description = '' } = cardData;

    return {
      name,
      cardData,
      description,
      status: status.toUpperCase(),
      createdAt: DateUtils.convertDateStringToFormat(cardData.created_at),
    };
  });

  return (
    <DataCardList
      key={view}
      data={data}
      view={view as any}
      isClientSideSearch
      searchPlaceholder="Search for IDs, names, and more..."
      availableFilterTypes={availableFilterTypes}
      detailViewTabs={detailViewTabs}
      urlId={urlId}
      loading={isLoading}
      noContentView={noContentView}
      loadData={loadData}
      enableSorting={false}
      rowRenderer={renderDataCardRow({ handleCardSelected, getData })}
      detailHeaderContent={
        <ServiceKeyDetailHeader
          {...getData(data.findIndex((item: any) => item.id === selectedCardId))}
        />
      }
    />
  );
};
